export default __webpack_public_path__ + "static/media/396.b50d943e.png";